// extracted by css-extract-rspack-plugin
export default {"iconWrapper":"mR4BWvNypJEvrHw2"};